import { createSlice } from "@reduxjs/toolkit"

export const usersAnalyticsListSlice = createSlice({
	name: "usersAnalytics",
	initialState: {
		usersAnalytics: "",
		errors: [],
	},

	reducers: {
        getUsersAnalytics: (state, action) => {
            // console.log(action.payload);
			state.usersAnalytics = action.payload
		},
		getUsersAnalyticsList: (state, action) => {
            
			state.usersAnalytics = action.payload
		},
		getErrors: (state, action) => {
			state.errors = action.payload
		},
	},
})
export const {getUsersAnalytics, getUsersAnalyticsList, getErrors} = usersAnalyticsListSlice.actions

export default usersAnalyticsListSlice.reducer

